<template>
  <div class="page" :style="{ minHeight: height + 'px' }">
    <Header></Header>
    <div v-if="!!visiterList.length">
      <div class="form">
        <p class="moduleTitle">{{ $t('appointment.visitors.photo.collection') }}</p>
        <div class="visiterItem" v-for="(item, index) of visiterList" v-bind:key="index">
          <FormItem :label="$t('user.apply.name')">
            <Input type="text" readonly v-model="item.name" :placeholder="$t('appointment.visited.name.tips')" />
          </FormItem>
          <FormItem :label="$t('appointment.visitors.image')">
            <Upload v-model="item.photo" />
          </FormItem>
        </div>
      </div>
      <div class="button">
        <Button color="#00CCBF" @click="submit" block>
          <span class="buttonText">{{ $t('common.submit') }}</span>
        </Button>
      </div>
    </div>
    <Empty v-else />
  </div>
</template>

<script>
import Upload from '@/components/upload.vue';
import { Button, Notify, Toast } from 'vant';
import api from '@/services/api';
import Header from '@/components/header.vue';
import FormItem from '@/components/formItem.vue';
import Input from '@/components/input.vue';
import Empty from './empty';

export default {
  components: {
    Upload,
    Button,
    FormItem,
    Header,
    Input,
    Empty,
  },

  data() {
    return {
      visiterList: [],
    };
  },
  computed: {
    recordId() {
      return this.$route.params.id;
    },
    height() {
      return window.innerHeight - parseInt(document.body.style.fontSize) * 1.17333;
    },
  },
  methods: {
    async initRecordList() {
      Toast.loading({
        duration: 0,
        forbidClick: true,
        message: this.$t('empty.loading') + '...',
      });
      const [status, res] = await api.getVisitorRecordList({ id: this.recordId });
      Toast.clear();
      if (!status) return;
      this.visiterList = res.data.map(i => ({
        ...i,
        photo: [
          {
            url: i.photo,
          },
        ],
      }));
    },
    auth() {
      return this.visiterList.map(i => {
        if (!i.photo) {
          Notify({
            type: 'warning',
            message: this.$t('appointment.visitors.image.tips'),
          });
          return false;
        }
      });
    },
    submit() {
      const arrList = this.auth();
      const index = arrList.findIndex(i => i === false);
      if (index !== -1) return;

      this.submitData();
    },
    submitData() {
      Toast.loading({
        duration: 0,
        forbidClick: true,
        message: this.$t('empty.loading') + '...',
      });

      const list = this.visiterList.map(i => ({ id: i.id, photo: i.photo[0].url }));

      api.putVisitorApply({ id: this.recordId, visitorInfos: list }).then(res => {
        Toast.clear();
        const [success] = res;
        if (success) {
          this.$router.push({ name: 'invitationResult' });
        }
      });
    },
  },
  created() {
    this.initRecordList();
  },
};
</script>

<style lang="less" scoped>
.page {
  //   display: flex;
  //   flex-direction: column;
  //   justify-content: space-between;
  .visiterItem {
    margin-bottom: 20px;
  }
  .moduleTitle {
    font-size: 26px;
    text-align: left;
    text-indent: 20px;
    padding: 20px 0;
  }

  .button {
    // position: fixed;
    height: 78px;
    bottom: 0;
    left: 0;
    right: 0;
    width: 690px;
    margin: 140px 0 128px 30px;
    .buttonText {
      font-size: 36px;
    }
  }
}
</style>
